import "semantic-ui-css/semantic.min.css";
import "./App.css";

import { Container } from "semantic-ui-react";
import ChatBox from "./components/ChatBox";
import CommentBox from "./components/ComentBox";

function App() {
  const windowUrl = window.location.search;
  const params = Object.fromEntries(new URLSearchParams(windowUrl));
  const isChat = params.isChat || "false";

  if (isChat === "false" || isChat === "null") {
    return (
      <Container>
        <CommentBox
          liveId={params.id}
          username={params.username}
          notModerated={params.notModerated}
          isOwner={params.isOwner}
          popUpFunctionName={params.popUpFunctionName}
          popUpModerated={params.popUpModerated}
        />
      </Container>
    );
  } else {
    return (
      <Container>
        <ChatBox
          liveId={params.liveId}
          chatId={params.chatId}
          username={params.username}
          notModerated={params.notModerated}
          isOwner={params.isOwner}
          popUpFunctionName={params.popUpFunctionName}
          popUpModerated={params.popUpModerated}
        />
      </Container>
    );
  }
}

export default App;
